const initialState = {
  hasFetched: false,
  pendingHasFetched: false,
  data: {},
  pendingPayoutsData: {},
  fetchError: null,
  isFetching: false,
  csvFetching: false
};

export default function payouts (state = initialState, action) {
  const {
    data,
    pendingPayoutsData,
    fetchError,
    type,
    csvFetching
  } = action;


  if ('PAYOUTS_FETCH_REQUEST' === type) {
    return { ...state, isFetching: true };
  }

  if ('PAYOUTS_FETCH_SUCCESS' === type) {
    return { ...state, data, hasFetched: true, isFetching: false };
  }

  if ('PAYOUTS_PENDING_FETCH_SUCCESS' === type) {
    return { ...state, pendingPayoutsData, pendingHasFetched: true, isFetching: false };
  }

  if ('PAYOUTS_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  if ('CSV_FETCHING' === type) {
    return { ...state, csvFetching };
  }

  return state;
}
